import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'hour4u-admin-edit-view-bill-details',
  templateUrl: './edit-view-bill-details.component.html',
  styleUrls: ['./edit-view-bill-details.component.scss']
})
export class EditViewBillDetailsComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EditViewBillDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public selectedProject: any,
    private router: Router,
    private jobService: JobService,
    private notify: NotificationService
  ) { }

  ngOnInit() {
    this.selectedProject.billingTitle = this.selectedProject.billingTitle ? this.selectedProject.billingTitle : "";
    console.log("%%%%%%%%%%%%%", this.selectedProject)

    if (this.selectedProject.selectedWorkOrders && this.selectedProject.selectedWorkOrders.length) {
      this.selectedProject.selectedWorkOrders.forEach(element => {
        console.log(element)
        if (element.workOrderDate && element.workOrderId) {
          let obj = {
            "jobId": this.selectedProject.id,
            "workOrderIds": [element.workOrderId]
          }
          this.jobService.fetchWorkorderByJobId(obj).subscribe(res => {
            console.log(res)
            element.dates = [];
            if (res && res.length) {
              element.jobTypeId = res[0].jobTypeId;
              element.dates = res[0].dates;
            }
          })
        }
      });
    }
  }

  removeSelectedWorkOrder(index) {
    if (index >= 0 && index < this.selectedProject.selectedWorkOrders.length) {
      this.selectedProject.selectedWorkOrders.splice(index, 1);
      this.jobService.saveBillingData(this.selectedProject);
    }
  }

  saveDetails() {
    if (this.selectedProject.title) {
      if (!this.selectedProject.selectedWorkOrders.length) {
        this.notify.showMessage("Please select at least one workorder!", 3000);
      } else {
        this.dialogRef.close(true);
        this.jobService.saveBillingData(this.selectedProject);
        this.router.navigateByUrl("/job/create-bill/" + this.selectedProject.id);
      }
    } else {
      this.notify.showMessage("Please enter bill name!", 3000);
    }
  }

  goToSpecificWorkOrder(workorder) {
    console.log("goToSpecificWorkOrder=======", workorder)
    let redircetUrl = "";
    let id = workorder.workOrderId ? workorder.workOrderId : workorder.id
    if (environment.api_url == 'https://devapi.hour4u.com') {
      redircetUrl = 'https://dev.workorbits.com/enterprise-admin/view-work-order/' + id
    }
    if (environment.api_url == 'https://api.hour4u.com') {
      redircetUrl = 'https://workorbits.com/enterprise-admin/view-work-order/' + id
    }

    // redircetUrl = 'http://localhost:4201/enterprise-admin/view-work-order/' + workorder.id
    window.open(redircetUrl, "_blank")
  }
}
